module.exports = __webpack_public_path__ + "static/img/image@1x.9788ac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/image@1x.png
// module id = IqO5
// module chunks = 44